import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { TaxCreditTransferDoc, tcDefaults, TC_CSS } from "@/pages/TaxCreditTransfer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public, token-signed print route for headless-Chrome PDF rendering / eFax.
export default function PrintTaxCredit() {
  const { appId } = useParams();
  const search = new URLSearchParams(useLocation().search);
  const t = search.get("t");
  const form = search.get("form") || null;
  const [app, setApp] = useState(null);
  const [shared, setShared] = useState(null);

  useEffect(() => {
    if (!appId || !t) return;
    (async () => {
      try {
        const r = await axios.get(`${API}/borrower/applications/${appId}/public?t=${encodeURIComponent(t)}`);
        const a = r.data.application || {};
        const saved = a.tax_credit_settings || {};
        setShared({ ...tcDefaults(), ...saved });
        setApp(a);
      } catch { /* leave blank */ }
    })();
  }, [appId, t]);

  if (!app || !shared) return <div style={{ padding: 40, fontFamily: "serif" }}>Loading…</div>;
  return (
    <div style={{ background: "#fff" }}>
      <div className="cm-print-area">
        <TaxCreditTransferDoc app={app} shared={shared} last formKey={form} />
      </div>
      <style>{TC_CSS}</style>
    </div>
  );
}
